import styled from "styled-components";
import { css } from "styled-components";
import { IE11Only } from "../../_utils/styleUtils";

const alignmentIE = css`
  top: 0;
  height: 4em;
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 1.1em;
  top: 1.6em;
  z-index: 2;

  /* Fix misalignment in IE11 */
  ${IE11Only(alignmentIE)};

  svg {
    width: 1.8em;
    height: auto;
  }

  > * {
    cursor: pointer;
  }
`;
